import { UPDATE_CURRENT_BREAKPOINT, ResponsiveAction } from 'store/responsive/actions';
import { createReducer } from 'store/createReducer';
import { MediaQuery } from 'models/MediaQueryService';

const reducer = {
  [UPDATE_CURRENT_BREAKPOINT]: (_: unknown, action: ResponsiveAction) => action.breakpoint
};

export default createReducer<number>(MediaQuery.Phone, reducer);
